export default "__VITE_PUBLIC_ASSET__1f43dea4__"